import { create } from 'zustand';

export const useUIStore = create((set) => ({
  sidebarOpen: true,
  searchOpen: false,
  commandOpen: false,

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setSearchOpen: (open) => set({ searchOpen: open }),
  setCommandOpen: (open) => set({ commandOpen: open }),
}));
